import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BODiagnosticNovo } from '../../models/BODiagnosticNovo.model';
import { Utilities } from '../../common/utilities';

@Component({
  selector: 'app-diagnostic-novo',
  templateUrl: './diagnostic-novo.component.html',
  styleUrls:  ['./diagnostic-novo.component.css' ]

})
export class DiagnosticNovoComponent implements OnInit, OnChanges {
      @Input() id!: number;

    @Input() patientId!: number;
    @Input() clinicHistoryId!: number;
    @Input() cie10Code!: string;
    @Input() cie10Name!: string;
    @Input() cie11Code!: string;
    @Input() cie11Name!: string;

    @Input() orphanDiseaseCode!: string;
    @Input() orphanDiseaseName!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Input() diagnosticType!: number;
    @Input() diagnosticCategory!: number;

    @Input() diseaseType!: number;
    @Input() details!:string;

    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number }>(); // ← Cambia el tipo

  diagnosticNovoList:BODiagnosticNovo[]=[];

  //#region types
  diagnosticTypeList=[
    {
      id:1,
      code:'01',
      name:'Impresión Diagnóstica'
    },
    {
      id:2,
      code:'02',
      name:'Confirmado Nuevo'
    },
    {
      id:3,
      code:'03',
      name:'Confirmado Repetido'
    },

  ];

  diseaseTypeList=[
    {
      id:1,
      code:'01',
      name:'Enfermedad Común'
    },
    {
      id:2,
      code:'02',
      name:'Enfermedad Huérfana'
    }
  ];

  diagnosticCategoryList=[
    {
      id:1,
      code:'01',
      name:'Diagn.Principal'
    },
    {
      id:2,
      code:'02',
      name:'Diagn.Relacionado'
    }
  ];
  //#endregion types


  constructor( private _formBuilder : FormBuilder)
  { }

  diagnosticFormGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    diseaseName:{ value: null, disabled: true },
    diseaseCode:{ value: null, disabled: true },

    diagnosticType:{ value: null, disabled: true },
    diagnosticCategory:{ value: null, disabled: true },
    diseaseType:{ value: null, disabled: true },
    details:{ value: null, disabled: true }
  })

  ngOnInit(): void {

    // if(this.diagnosticCategory==1)
    // {
        if(this.diseaseType==1)
        {
          this.diagnosticFormGroup.patchValue({
            posInArray: this.posInArray +1,
            diseaseName: this.cie10Name,
            diseaseCode: this.cie10Code,
            diagnosticType: Utilities.getNameWithNumberFromList(this.diagnosticType, this.diagnosticTypeList),
            diseaseType:Utilities.getNameWithNumberFromList(this.diseaseType, this.diseaseTypeList),
            details:this.details
          })
        }
        else
        {
          this.diagnosticFormGroup.patchValue({
            posInArray: this.posInArray +1,
            diseaseCode: this.orphanDiseaseCode,
            diseaseName: this.orphanDiseaseName,
            diagnosticType: Utilities.getNameWithNumberFromList(this.diagnosticType, this.diagnosticTypeList),
            diseaseType:Utilities.getNameWithNumberFromList(this.diseaseType, this.diseaseTypeList),
            details:this.details
          })

        }

   // }
    // else
    // {

    //     if(this.diseaseType==1)
    //     {
    //       this.diagnosticFormGroup.patchValue({
    //         posInArray: this.posInArray +1,
    //         diseaseName: this.cie10Name,
    //         diagnosticType:this.diagnosticType,
    //         diseaseType:this.diseaseType,
    //         details:this.details
    //       })
    //     }
    //     else
    //     {
    //       this.diagnosticFormGroup.patchValue({
    //         posInArray: this.posInArray +1,
    //         diseaseName: this.orphanDiseaseName,
    //         diseaseType:this.diseaseType,
    //         details:this.details
    //       })

    //     }
    // }



  }
  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.diagnosticFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }



    // private patchForm(): void {
    //     this.relativeDiseaseGroup.patchValue({
    //     posInArray: this.posInArray +1,
    //     relativeType: Utilities.getRelativeTypeName(this.relativeTypeCode, this.relativeTypeList),
    //     cei10Code: this.cei10Code,
    //     cei10Name: this.cei10Name,
    //    })

    // }


deleteItem(): void {
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
}


deleteItemSingle(): void {
  console.log("ENTRA EN DELETEITEMSINGLE, EN DIAGNOSTICNOVO COMPONENT");
  this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición
}


}
